import { LoadingScreen } from '@/components/common/LoadingScreen';
import { TermsAcceptanceScreen } from '@/components/terms/TermsAcceptanceScreen';
import { useAuth } from '@/hooks/useAuth';
import React, { useState } from 'react';

interface TermsGuardProps {
  children: React.ReactNode;
}

export const TermsGuard: React.FC<TermsGuardProps> = ({ children }) => {
  const { user, hasManagerRole, hasOwnerRole, isLoadingUser } = useAuth();
  const [areTermsAccepted, setAreTermsAccepted] = useState(false);

  if (isLoadingUser) {
    return <LoadingScreen />;
  }

  const requiresTermsAcceptance =
    (hasManagerRole || hasOwnerRole) && user && !user.termsAccepted;

  if (requiresTermsAcceptance && !areTermsAccepted) {
    return (
      <TermsAcceptanceScreen
        onTermsAccepted={() => setAreTermsAccepted(true)}
      />
    );
  }

  return <>{children}</>;
};
